var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGoogleLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 49,
    viewBox: "0 0 55 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5659 13.4653H34.9432C30.0231 9.06599 22.8604 9.66869 18.6 14.8374C18.5651 14.8343 18.5292 14.8445 18.4942 14.8624C18.4536 14.883 18.4118 14.9151 18.3702 14.9539C18.2871 15.0316 18.2014 15.1396 18.1245 15.2481C18.0474 15.3568 17.9784 15.4672 17.9287 15.5503C17.9039 15.5918 17.8838 15.6266 17.87 15.651L17.8544 15.6788L8.31161 17.4221C7.76937 17.2558 7.1932 17.2896 6.67062 17.5134C7.53747 14.0139 9.11251 10.7797 11.2818 8.0626L11.2818 8.06259C19.1241 -1.77051 32.6789 -2.71067 41.5653 5.96236L41.3331 8.18884L36.5659 13.4653Z",
    fill: "#EA4335",
    stroke: "#DEF6FC",
    strokeWidth: 0.0517843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1437 17.5648L48.1459 17.5738L48.1533 17.5793C52.4513 20.797 55.0133 26.1826 54.9737 31.9414C54.9078 41.4233 47.908 49.0465 39.3474 48.9735H39.3472H27.4139L26.2365 47.6703V39.7605L27.414 38.4391H39.3472C42.6621 38.4391 45.3455 35.465 45.3455 31.8027C45.3455 28.1499 42.6761 25.1819 39.3731 25.1664V23.8733C39.4423 19.8267 37.8326 15.9652 35.006 13.3983L41.6792 6.01213C44.802 9.08301 47.0476 13.0983 48.1437 17.5648Z",
    fill: "#4285F4",
    stroke: "#DEF6FC",
    strokeWidth: 0.0517843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4413 48.8893L15.4412 48.8893C12.0686 48.9075 8.78437 47.7003 6.0938 45.4523L6.5081 43.618L11.3126 38.3367L12.9732 37.765C13.7498 38.1546 14.5889 38.3585 15.4413 38.3585H27.3602V48.8893H15.4413Z",
    fill: "#34A853",
    stroke: "#DEF6FC",
    strokeWidth: 0.0517843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9004 28.9482C20.2947 27.4952 19.2376 26.3281 17.9191 25.6694C14.8997 24.16 11.345 25.6486 9.98312 28.9862C8.62623 32.3114 9.95333 36.2286 12.9497 37.7483L6.06275 45.371C2.28052 42.1454 0.0557807 37.169 0.0261563 31.8826C-0.0233048 22.3971 6.87763 14.668 15.4415 14.6133C20.2758 14.5914 24.8448 17.0759 27.7857 21.3273L20.9004 28.9482Z",
    fill: "#FBBC05",
    stroke: "#DEF6FC",
    strokeWidth: 0.0517843
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleLogo);
export default __webpack_public_path__ + "static/media/Icon_Google_Logo.0bad7e7fc99c68dff006b70dcab00a50.svg";
export { ForwardRef as ReactComponent };